export function validators(madSDK) {
    return {
        publisherSettings: (item, value) => {
            const arrVal = Array.isArray(value) ? value : [];
            // Validate each publisher setting
            for (const publisherSetting of arrVal) {
                const validation = madSDK.publishers.optimizationTemplates.publisherSettings.validate(publisherSetting);
                if (validation?.size > 0) {
                    return validation.values().next().value;
                }
            }
            // Validate publisher caps sum to 100% if inventoryPackagesV2 exists
            if (item?.inventoryPackagesV2?.length) {
                const totalCaps = arrVal.reduce((sum, setting) => sum + (setting.pubCapPct || 0), 0);
                if (totalCaps < 100) {
                    return "Publisher caps must sum to at least 100%";
                }
            }
            return undefined;
        }
    };
}
//# sourceMappingURL=validators.js.map